const faqs = [
  {
    q: '久久影视上的内容更新速度快吗？',
    a: '非常快！我们的编辑团队全天候追踪全网最新电视剧更新动态，热门新剧上线后通常在数小时内就会收录到平台。最新电影上映信息也会在定档后第一时间同步，让你永远走在追剧第一线。',
  },
  {
    q: '久久影视是否需要付费？有没有广告？',
    a: '久久影视是一个完全免费的影视资讯导航平台，我们只提供内容发现和整理服务，不收取任何费用。页面干净清爽，没有弹窗广告和强制跳转，给你最纯粹的追剧体验。',
  },
  {
    q: '如何第一时间知道新剧上线？',
    a: '关注久久影视首页的"最新动态"和"热播精选"板块即可。我们会在新剧定档、开播、更新时第一时间更新内容。建议将久久影视加入浏览器收藏夹，每天打开看一眼，好剧不错过。',
  },
  {
    q: '久久影视支持手机和平板观看吗？',
    a: '当然支持！久久影视采用响应式设计，在手机、平板和电脑上都能获得流畅的浏览体验。高清不卡是我们对追剧党的承诺，无论你用什么设备追剧，画面都清晰流畅。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于久久影视，你可能想知道的
          </p>
        </div>
        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200/70"
            >
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  {idx + 1}
                </span>
                {faq.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}